'use es6';

export const secureDocument = document.implementation.createHTMLDocument('');